var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useMemo, useRef } from 'react';
import { ELEMENT_TYPE, ITEM_RENDER_MODE, SEPARATOR, SIZE } from '../../constants';
import { useBreadcrumbsLayout } from '../../hooks';
import { Collapse } from '../Collapse';
import { Crumb } from '../Crumb';
import { HiddenChain } from '../HiddenChain';
import { Separator } from '../Separator';
import { Wrapper } from '../Wrapper';
/**
 * Компонент хлебных крошек
 */
export const Breadcrumbs = memo(function Breadcrumbs(_a) {
    var { items: itemsProps, size = SIZE.S, separator = SEPARATOR, className, firstItemIconOnly = false, inactiveLastItem = false, lastEmpty = false } = _a, rest = __rest(_a, ["items", "size", "separator", "className", "firstItemIconOnly", "inactiveLastItem", "lastEmpty"]);
    const containerRef = useRef(null);
    const { setConfigs, currentConfig } = useBreadcrumbsLayout(containerRef);
    const items = useMemo(() => inactiveLastItem
        ? itemsProps.map((item, index) => index === itemsProps.length - 1 ? Object.assign(Object.assign({}, item), { onClick: undefined, href: undefined }) : item)
        : itemsProps, [inactiveLastItem, itemsProps]);
    return (_jsxs(_Fragment, { children: [_jsx(HiddenChain, { items: items, size: size, separator: separator, onConfigsBuilt: setConfigs, firstItemIconOnly: firstItemIconOnly, lastEmpty: lastEmpty }), _jsx(Wrapper, Object.assign({}, rest, { ref: containerRef, hidden: false, size: size, separator: separator, className: className, children: currentConfig === null || currentConfig === void 0 ? void 0 : currentConfig.chain.map((block, index, array) => {
                    const isLastElement = index === array.length - 1;
                    switch (block.element) {
                        case ELEMENT_TYPE.Separator:
                            return _jsx(Separator, {}, index);
                        case ELEMENT_TYPE.Collapse:
                            return _jsx(Collapse, { currentConfig: currentConfig.chain }, index);
                        case ELEMENT_TYPE.Item: {
                            const { renderMode, id } = block.item;
                            if (renderMode !== ITEM_RENDER_MODE.Collapsed) {
                                return (_jsx(Crumb, { useIconOnly: !index && firstItemIconOnly, current: isLastElement, renderMode: renderMode, minWidth: block.width, item: block.item }, id));
                            }
                            break;
                        }
                        default:
                            return null;
                    }
                }) }))] }));
});
